import { render, staticRenderFns } from "./AngpowBody.vue?vue&type=template&id=2b11f306&scoped=true&"
import script from "./AngpowBody.vue?vue&type=script&lang=ts&"
export * from "./AngpowBody.vue?vue&type=script&lang=ts&"
import style0 from "./AngpowBody.vue?vue&type=style&index=0&id=2b11f306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b11f306",
  null
  
)

export default component.exports